import gql from "graphql-tag";
const PAGES = gql`
	query ($take: Int) {
		pages(take: $take) {
			items {
				id
				createdBy {
					id
					name
				}
				createdOn
				modifiedBy {
					id
					name
				}
				modifiedOn
				title
				code
				titleFileId
				group {
					id
					name
				}
			}
		}
	}
`;
const PAGES_SECTION = gql`
	query (
		$where: PageFilterInput
		$order: [PageSortInput!]
		$skip: Int
		$take: Int
	) {
		pages(where: $where, order: $order, skip: $skip, take: $take) {
			totalCount
			pageInfo {
				hasNextPage
			}
			items {
				id
				createdBy {
					id
					name
				}
				createdOn
				modifiedBy {
					id
					name
				}
				modifiedOn
				title
				code
				titleFileId
				group {
					id
					name
				}
			}
		}
	}
`;
const PAGE_FOR_VIEW = gql`
	query ($where: PagesQueryResponseFilterInput) {
		pagesWithLike(where: $where) {
			items {
				isLiked
				isDisliked
				likesCount
				dislikesCount
				isFavorite
				entity {
					id
					createdOn
					title
					code
					content
					titleFileId
					useReactions
					useComments
				}
			}
		}
	}
`;
const PAGES_FOR_EDIT = gql`
	query ($where: PageFilterInput) {
		items: pagesForEdit(where: $where) {
			items {
				id
				createdBy {
					name
				}
				createdOn
				modifiedBy {
					name
				}
				modifiedOn
				title
				metaTitle
				metaDescription
				content
				code
				culture {
					id
				}
				titleFileId
				group {
					id
					name
				}
				tags {
					id
					name
				}
				useReactions
				useComments
			}
		}
	}
`;
const PAGE_TAGS = gql`
	query (
		$where: TagFilterInput
		$order: [TagSortInput!]
		$skip: Int
		$take: Int
	) {
		pageTags(where: $where, order: $order, skip: $skip, take: $take) {
			pageInfo {
				hasNextPage
			}
			items {
				id
				name
			}
		}
	}
`;
const DELETE_PAGES_TAG = gql`
	mutation ($id: UUID!) {
		deletePagesTag(id: $id)
	}
`;
const ADD_OR_EDIT_PAGE = gql`
	mutation ($inputs: [PageInput!]!) {
		result: addOrEditPage(inputs: $inputs)
	}
`;
const DELETE_PAGE = gql`
	mutation ($code: String!) {
		deletePage(code: $code)
	}
`;
const ADD_PAGE_REACTION = gql`
	mutation ($input: BaseEntityReactionInput!) {
		addPageReaction(input: $input) {
			isLiked
			isDisliked
			likesCount
			dislikesCount
		}
	}
`;
const USER_TEMPLATES = gql`
	query {
		userTemplates {
			items {
				id
				key
				name
				template
				createdBy {
					id
					name
				}
				isPublic
			}
		}
	}
`;
const ADD_OR_EDIT_USER_TEMPLATE = gql`
	mutation ($input: UserTemplateInput!) {
		addOrEditUserTemplate(input: $input) {
			id
			isPublic
		}
	}
`;
export {
  ADD_OR_EDIT_PAGE,
  ADD_OR_EDIT_USER_TEMPLATE,
  ADD_PAGE_REACTION,
  DELETE_PAGE,
  DELETE_PAGES_TAG,
  PAGES,
  PAGES_FOR_EDIT,
  PAGES_SECTION,
  PAGE_FOR_VIEW,
  PAGE_TAGS,
  USER_TEMPLATES
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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
